import { ProductPlan } from '@/types/productPlans';

interface NormalizedMRR {
  mrr_normalized: number;
  coverage_months: number;
  period_end_date: Date;
}

const RECURRENCE_MONTHS: Record<string, number> = {
  'daily': 1/30,
  'weekly': 1/4,
  'monthly': 1,
  'bimonthly': 2,
  'quarterly': 3,
  'semiannual': 6,
  'annual': 12,
  'lifetime': 12, // Convenção: lifetime = 1 ano de MRR
  'custom': 1, // Padrão mensal
};

export function normalizeMRR(
  amountPaid: number,
  recurrenceType: ProductPlan['recurrence_type'],
  paymentDate: Date
): NormalizedMRR {
  const coverageMonths = RECURRENCE_MONTHS[recurrenceType] || 1;
  const mrrNormalized = amountPaid / coverageMonths;
  
  const periodEndDate = new Date(paymentDate);
  periodEndDate.setMonth(periodEndDate.getMonth() + Math.ceil(coverageMonths));
  
  return {
    mrr_normalized: mrrNormalized,
    coverage_months: Math.ceil(coverageMonths),
    period_end_date: periodEndDate,
  };
}

export function detectRenewal(
  previousTransactions: any[],
  productPlanId: string
): { isRenewal: boolean; previousTxId: string | null } {
  // Buscar transação anterior no mesmo plano
  const previousTx = previousTransactions.find(t => t.product_plan_id === productPlanId);
  
  return {
    isRenewal: !!previousTx,
    previousTxId: previousTx?.id || null
  };
}
